import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './authShared.css';
import { useTheme } from '../ThemeContext';
import logoLight from '../images/QuiblyLight.png';
import logoDark from '../images/QuiblyDark.png';

const ForgotPassword = () => {
  const { darkMode } = useTheme();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch('https://quibly.onrender.com/api/user/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.error || 'An error occurred');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`authPage ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="authCard">
        <Link to="/" className="authLogoLink">
          <img src={darkMode ? logoDark : logoLight} alt="Quibly" className="authLogo" />
        </Link>

        <h1 className="authTitle">Reset password</h1>
        <p className="authSubtitle">
          {success
            ? 'Check your inbox for a temporary password.'
            : 'Enter your email and we\u2019ll send you a temporary password.'}
        </p>

        {success ? (
          <div className="authForm">
            <div className="authSuccess">
              A temporary password has been sent to your email. Use it to log in, then change your password in settings.
            </div>
            <button type="button" className="authBtn solid" onClick={() => navigate('/login')}>
              Back to login
            </button>
          </div>
        ) : (
          <form className="authForm" onSubmit={handleSubmit}>
            <div className="authField">
              <label className="authLabel" htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                className="authInput"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                autoComplete="email"
                required
              />
            </div>

            {error && <div className="authError">{error}</div>}

            <button type="submit" className="authBtn solid" disabled={isLoading}>
              {isLoading ? 'Sending…' : 'Send reset email'}
            </button>
          </form>
        )}

        {!success && (
          <p className="authFooter">
            Remember your password? <Link to="/login">Log in</Link>
          </p>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
